import { AxiosInstance } from 'axios';

import { SettingsAPIApiFactory } from '@cast/openapi-organization-management';

import { AXIOS_CONFIGURATION } from '../constants';

export const OrganizationSettingsApiAdapter = (client: AxiosInstance) => {
  const organizationSettingsGeneratedApi = SettingsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getOrganizationSettings:
      organizationSettingsGeneratedApi.settingsAPIGetSettings,
    updateOrganizationSettings:
      organizationSettingsGeneratedApi.settingsAPIUpdateSettings,
  };
};
